import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { baseurladdress } from "../baseurl"
import Moment from "moment";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

function Editstaff() {
    const { staff_id } = useParams();
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [filename, setFileName] = useState("");
    const [filestaffname, setFilestaffName] = useState("");
    const [staff_name, setstaff_name] = useState("");
    const [staff_spouse, setstaff_spouse] = useState("");
    const [staff_father, setstaff_father] = useState("");
    const [staff_code, setstaff_code] = useState("");
    const [staff_door, setstaff_door] = useState("");
    const [staff_street, setstaff_street] = useState("");
    const [staff_dob, setstaff_dob] = useState("");
    const [staff_gender, setstaff_gender] = useState("");
    const [staff_place, setstaff_place] = useState("");
    const [staff_district, setstaff_district] = useState("");
    const [staff_state, setstaff_state] = useState("");
    const [staff_cntry, setstaff_cntry] = useState("");
    const [staff_pin, setstaff_pin] = useState("");
    const [staff_email, setstaff_email] = useState("");
    const [staff_brief, setstaff_brief] = useState("");
    const [staff_mobile, setstaff_mobile] = useState("");
    const [staff_phone, setstaff_phone] = useState("");
    const [staff_status, setstaff_status] = useState("");
    const [staff_region, setstaff_region] = useState("");
    const [staff_password, setstaff_password] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [staff_username, setstaff_username] = useState("");



    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [file, setFile] = useState('');

    // Manager and Area states
    const [regionalManagers, setRegionalManagers] = useState([]);
    const [selectedRegionalManager, setSelectedRegionalManager] = useState("");
    const [areaManagers, setAreaManagers] = useState([]);
    const [selectedAreaManager, setSelectedAreaManager] = useState("");
    const [availableAreas, setAvailableAreas] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [showAreaModal, setShowAreaModal] = useState(false);
    const [primaryRegionId, setPrimaryRegionId] = useState(null);

    const [ButtonDisabled, setisButtonDisabled] = useState("disable");
    const [ButtonsignDisabled, setisButtonsignDisabled] = useState("disable");

    const Swal = require('sweetalert2')

    let navigate = useNavigate();

    // Load staff details
    useEffect(() => {
        axios
            .get(baseurladdress + `staff/editstaff/${staff_id}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const data = res.data.staff;

                    setstaff_name(data.staff_name);
                    setstaff_password(data.user_pass);
                    setstaff_username(data.user_name);
                    setstaff_spouse(data.staff_spouse);
                    setstaff_father(data.staff_father);
                    setstaff_code(data.staff_code);
                    setstaff_street(data.staff_street);
                    setstaff_dob(data.staff_dob);
                    setstaff_gender(data.staff_gender);
                    setstaff_place(data.staff_place);
                    setstaff_district(data.staff_district);
                    setstaff_state(data.staff_state);
                    setstaff_cntry(data.staff_cntry);
                    setstaff_pin(data.staff_pin);
                    setstaff_email(data.staff_email);
                    setstaff_brief(data.staff_brief);
                    setstaff_mobile(data.staff_mobile);
                    setstaff_phone(data.staff_phone);
                    setstaff_status(data.staff_status);
                    setstaff_region(data.staff_region);

                    // Parse staff areas (comma-separated string to array)
                    if (data.staff_area) {
                        const areaIds = data.staff_area.split(',').map(id => parseInt(id.trim()));
                        setSelectedAreas(areaIds);
                    }

                    // Load dropdown dependencies
                    getcountry();
                    getstate(data.staff_cntry);
                    getdistrict(data.staff_state);
                } else {
                    console.warn("Staff not found");
                }
            })
            .catch((error) => {
                console.error("Edit staff fetch error:", error);
            });
    }, [staff_id]);

    // Load Regional Managers on component mount
    useEffect(() => {
        axios
            .get(baseurladdress + "region/regional-managers", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    setRegionalManagers(res.data.managers);
                } else {
                    setRegionalManagers([]);
                }
            })
            .catch((error) => {
                console.error("Failed to load regional managers:", error);
                setRegionalManagers([]);
            });
    }, []);

    // Determine Regional Manager based on staff_region
    useEffect(() => {
        if (staff_region && regionalManagers.length > 0) {
            // Get the regional manager for this region
            axios
                .get(baseurladdress + `staff/getregionalmanager/${staff_region}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success" && res.data.manager) {
                        setSelectedRegionalManager(res.data.manager.user_id.toString());
                    }
                })
                .catch((error) => {
                    console.error("Failed to load regional manager:", error);
                });
        }
    }, [staff_region, regionalManagers]);

    // Determine Area Manager based on selected areas
    useEffect(() => {
        if (selectedAreas.length > 0 && !selectedAreaManager) {
            axios
                .get(baseurladdress + `staff/getareamanager/${selectedAreas[0]}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success" && res.data.manager) {
                        setSelectedAreaManager(res.data.manager.user_id.toString());
                    }
                })
                .catch((error) => {
                    console.error("Failed to load area manager:", error);
                });
        }
    }, [selectedAreas]); // removed selectedRegionalManager dependency

    // Load Area Managers when Regional Manager is selected
    useEffect(() => {
        if (selectedRegionalManager) {
            axios
                .get(baseurladdress + `staff/getareamanagersbyregionalmanager/${selectedRegionalManager}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        setAreaManagers(res.data.managers);
                    } else {
                        setAreaManagers([]);
                    }
                })
                .catch((error) => {
                    console.error("Failed to load area managers:", error);
                    setAreaManagers([]);
                });
        } else {
            setAreaManagers([]);
            setSelectedAreaManager("");
            setAvailableAreas([]);
        }
    }, [selectedRegionalManager]);

    // Load Areas when Area Manager is selected
    useEffect(() => {
        if (selectedAreaManager) {
            axios
                .get(baseurladdress + `staff/getareasbyareamanager/${selectedAreaManager}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        setAvailableAreas(res.data.areas);
                        // Set primary region from first area
                        if (res.data.areas.length > 0) {
                            setPrimaryRegionId(res.data.areas[0].aregion_id);
                        }
                    } else {
                        setAvailableAreas([]);
                    }
                })
                .catch((error) => {
                    console.error("Failed to load areas:", error);
                    setAvailableAreas([]);
                });
        } else {
            setAvailableAreas([]);
        }
    }, [selectedAreaManager]);

    // Handle area checkbox toggle
    const handleAreaToggle = (areaId) => {
        setSelectedAreas(prev => {
            if (prev.includes(areaId)) {
                return prev.filter(id => id !== areaId);
            } else {
                return [...prev, areaId];
            }
        });
    };

    // Select all areas
    const handleSelectAll = () => {
        if (selectedAreas.length === availableAreas.length) {
            setSelectedAreas([]);
        } else {
            setSelectedAreas(availableAreas.map(area => area.area_id));
        }
    };

    // getcountry
    const getcountry = () => {
        axios
            .get(baseurladdress + "staff/getallcountry", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    setcntry_name(res.data.countries);
                } else {
                    setcntry_name([]);
                }
            })
            .catch((error) => {
                console.error("Country fetch error:", error);
                alert("Failed to load countries");
            });
    };

    const getcountryname = (event) => {
        setstaff_state("");
        setstaff_district("");
        setdistrict_name([]);
    }

    const getstatename = (event) => {
        setstaff_district("");
    }

    // getstate
    const getstate = (countryId) => {
        if (!countryId) {
            setstate_name([]);
            return;
        }

        axios
            .get(`${baseurladdress}staff/getstates/${countryId}`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
                if (res.data?.status === "Success") {
                    setstate_name(res.data.states);
                } else {
                    setstate_name([]);
                }
            })
            .catch((error) => {
                console.error("State fetch error:", error);
                alert("Failed to load states");
            });
    };

    // get district
    const getdistrict = (district_state) => {
        if (!district_state) {
            setdistrict_name([]);
            return;
        }

        axios.get(`${baseurladdress}staff/getdistricts/${district_state}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                if (res.data?.status === "Success") {
                    setdistrict_name(res.data.districts);
                } else {
                    setdistrict_name([]);
                }
            })
            .catch(error => {
                console.error("District fetch error:", error);
                alert("Failed to load districts");
            });
    };

    const changeTitle = (staffcntry) => {
        if (!staffcntry) {
            setstate_name([]);
            return;
        }

        axios.get(`${baseurladdress}staff/getstates/${staffcntry}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                if (res.data?.status === "Success") {
                    setstate_name(res.data.states);
                } else {
                    setstate_name([]);
                }
            })
            .catch(error => {
                alert("Failed to load states");
                console.error(error);
            });
    };

    const changeDistricts = (staffdistrict) => {
        if (!staffdistrict) {
            setdistrict_name([]);
            return;
        }

        axios.get(`${baseurladdress}staff/getdistricts/${staffdistrict}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                if (res.data?.status === "Success") {
                    setdistrict_name(res.data.districts);
                } else {
                    setdistrict_name([]);
                }
            })
            .catch(error => {
                alert("Failed to load districts");
                console.error(error);
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!staff_password || staff_password.length < 6) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Password",
                text: "Password is required and must be at least 6 characters long",
            });
            return;
        }

        // Convert selectedAreas array to comma-separated string
        const staff_area = selectedAreas.length > 0
            ? selectedAreas.join(',')
            : null;

        const data = {
            staff_id,
            staff_name,
            staff_spouse,
            staff_father,
            staff_code,
            staff_dob: staff_dob ? new Date(staff_dob).toISOString().split('T')[0] : null,
            staff_gender,
            staff_mobile,
            staff_phone,
            staff_email,
            staff_brief,
            staff_street,
            staff_place,
            staff_cntry,
            staff_state,
            staff_district,
            staff_pin,
            staff_status,
            staff_area,
            staff_region: primaryRegionId || staff_region,
            staff_password,
            staff_username,
            staff_updby: accessuserid
        };

        fetch(baseurladdress + "staff/updatestaffdetails", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 800,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                });

                if (result.status === "Success") {
                    Toast.fire({
                        icon: "Success",
                        title: "Edited Successfully",
                    });
                    navigate("/staff");
                } else {
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong",
                    });
                }
            })
            .catch((error) => {
                console.error("Update error:", error);
            });
    };


    return (
        <>
            <div className="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink to="/staff">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                    <form>
                        <div className="row">
                            {/* LEFT CARD */}
                            <div className="col-xl-6 col-xxl-6 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Edit Staff Details</h4>
                                    </div>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6 mb-3">
                                                <h6>Staff Name</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_name}
                                                    onChange={(e) => setstaff_name(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <h6>Staff Code</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_code}
                                                    onChange={(e) => setstaff_code(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <h6>Username</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_username}
                                                    onChange={(e) => setstaff_username(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                <h6>DOB</h6>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={staff_dob ? Moment(staff_dob).format("YYYY-MM-DD") : ""}
                                                    onChange={(e) => setstaff_dob(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>Gender</h6>
                                                <select
                                                    className="form-control select"
                                                    name="employee"
                                                    id="employee"
                                                    value={staff_gender}
                                                    onChange={(e) => setstaff_gender(e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="1">Male</option>
                                                    <option value="2">Female</option>
                                                    <option value="3">Other</option>
                                                </select>
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>Mobile</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_mobile}
                                                    pattern="[0-9\-\+\s]+"
                                                    minLength="10"
                                                    maxLength="14"
                                                    onChange={(e) => setstaff_mobile(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>Phone</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_phone}
                                                    pattern="[0-9\-\+\s]+"
                                                    minLength="10"
                                                    maxLength="12"
                                                    onChange={(e) => setstaff_phone(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-8 mb-3">
                                                <h6>Email</h6>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={staff_email}
                                                    onChange={(e) => setstaff_email(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <label>Password</label>

                                                <div style={{ position: "relative" }}>
                                                    <input
                                                        type={showPassword ? "text" : "password"} // toggle type
                                                        id="user_pass"
                                                        placeholder="Password"
                                                        style={{ paddingRight: "40px" }} // space for the eye
                                                        value={staff_password}
                                                        onChange={(e) => setstaff_password(e.target.value)}
                                                        className="form-control"
                                                    />

                                                    <i
                                                        className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} text-secondary`}
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        style={{
                                                            position: "absolute",
                                                            right: "12px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            cursor: "pointer",
                                                            fontSize: "16px"
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>



                                            <div className="col-12 mb-3">
                                                <h6>Brief</h6>
                                                <textarea
                                                    className="form-control"
                                                    style={{ height: "7em" }}
                                                    value={staff_brief}
                                                    onChange={(e) => setstaff_brief(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT CARD */}
                            <div className="col-xl-6 col-xxl-6 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6 mb-3">
                                                <h6>Father Name</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_father}
                                                    onChange={(e) => setstaff_father(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <h6>Spouse Name</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_spouse}
                                                    onChange={(e) => setstaff_spouse(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <h6>Street</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_street}
                                                    onChange={(e) => setstaff_street(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-3">
                                                <h6>Place</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={staff_place}
                                                    onChange={(e) => setstaff_place(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>Country</h6>
                                                <select
                                                    className="form-control select"
                                                    name="Country"
                                                    value={staff_cntry}
                                                    onChange={(e) => { changeTitle(e.target.value); getcountryname(e); setstaff_cntry(e.target.value); }}
                                                >
                                                    <option value="">Select</option>
                                                    {cntry_name.map((obj) => (
                                                        <option key={obj.cntry_id} value={obj.cntry_id}>{obj.cntry_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>State</h6>
                                                <select
                                                    className="form-control select"
                                                    name="State"
                                                    value={staff_state}
                                                    onChange={(e) => { changeDistricts(e.target.value); getstatename(e); setstaff_state(e.target.value); }}
                                                >
                                                    <option value="">Select</option>
                                                    {state_name.map((obj) => (
                                                        <option key={obj.state_id} value={obj.state_id}>{obj.state_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-sm-4 mb-3">
                                                <h6>District</h6>
                                                <select
                                                    className="form-control select"
                                                    name="District"
                                                    value={staff_district}
                                                    onChange={(e) => setstaff_district(e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {district_name.map((obj) => (
                                                        <option key={obj.district_id} value={obj.district_id}>{obj.district_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-sm-8 mb-3">
                                                <h6>Pin</h6>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Pin"
                                                    value={staff_pin}
                                                    pattern="[0-9\-\+\s]+"
                                                    minLength="6"
                                                    maxLength="6"
                                                    onChange={(e) => setstaff_pin(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                <br />
                                                <input
                                                    type="checkbox"
                                                    name="staff_status"
                                                    className="selectsingle checku"
                                                    checked={staff_status === 1}
                                                    onChange={(e) => setstaff_status(e.target.checked ? 1 : 0)}
                                                />
                                                <label className="form__label textal offset-1" htmlFor="staff_status">Status</label>
                                            </div>

                                            {/* Regional Manager Dropdown */}
                                            <div className="col-sm-6 mb-3">
                                                <h6>Regional Manager <span style={{ color: "red" }}>*</span></h6>
                                                <select
                                                    className="form-control select"
                                                    value={selectedRegionalManager}
                                                    onChange={(e) => {
                                                        setSelectedRegionalManager(e.target.value);
                                                        setSelectedAreaManager("");
                                                        setAvailableAreas([]);
                                                        setSelectedAreas([]);
                                                    }}
                                                    required
                                                >
                                                    <option value="" disabled>Select Regional Manager</option>
                                                    {regionalManagers.map((manager) => (
                                                        <option key={manager.user_id} value={manager.user_id}>
                                                            {manager.user_staffname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Area Manager Dropdown */}
                                            <div className="col-sm-6 mb-3">
                                                <h6>Area Manager <span style={{ color: "red" }}>*</span></h6>
                                                <select
                                                    className="form-control select"
                                                    value={selectedAreaManager}
                                                    onChange={(e) => {
                                                        setSelectedAreaManager(e.target.value);
                                                        setSelectedAreas([]);
                                                    }}
                                                    disabled={!selectedRegionalManager}
                                                    required
                                                >
                                                    <option value="" disabled>
                                                        {selectedRegionalManager ? "Select Area Manager" : "Select Regional Manager First"}
                                                    </option>
                                                    {areaManagers.map((manager) => (
                                                        <option key={manager.user_id} value={manager.user_id}>
                                                            {manager.user_staffname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* ASSIGN AREAS BUTTON */}
                                            <div className="col-12 mb-3">
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (!selectedAreaManager) {
                                                            Swal.fire({
                                                                icon: "warning",
                                                                title: "Selection Required",
                                                                text: "Please select an Area Manager first",
                                                            });
                                                            return;
                                                        }
                                                        setShowAreaModal(true);
                                                    }}
                                                    disabled={!selectedAreaManager}
                                                    className="btn btn-success w-100"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '8px',
                                                        backgroundColor: selectedAreaManager ? '#28a745' : '#cccccc',
                                                        cursor: selectedAreaManager ? 'pointer' : 'not-allowed'
                                                    }}
                                                >
                                                    <i className="fa fa-map-marker"></i>
                                                    Edit Assigned Areas ({selectedAreas.length} selected)
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* UPDATE BUTTON */}
                            <div className="col-12 text-center mt-4">
                                <button className="btn btn-primary px-5" onClick={handleSubmit}>Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* AREA ASSIGNMENT MODAL */}
            {showAreaModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '85vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            padding: '20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                Edit Assigned Areas
                            </h3>
                            <button
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div style={{
                            padding: '20px',
                            flex: 1,
                            overflowY: 'auto'
                        }}>
                            <div style={{
                                marginBottom: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingBottom: '15px',
                                borderBottom: '2px solid #e0e0e0'
                            }}>
                                <button
                                    type="button"
                                    onClick={handleSelectAll}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {selectedAreas.length === availableAreas.length ? 'Deselect All' : 'Select All'}
                                </button>
                                <span style={{ color: '#666', fontSize: '14px', fontWeight: '500' }}>
                                    {selectedAreas.length} of {availableAreas.length} areas selected
                                </span>
                            </div>

                            {availableAreas.length === 0 ? (
                                <p style={{
                                    textAlign: 'center',
                                    color: '#999',
                                    padding: '40px 20px',
                                    margin: 0
                                }}>
                                    No areas available for this Area Manager
                                </p>
                            ) : (
                                <div>
                                    {availableAreas.map((area, index) => (
                                        <div
                                            key={area.area_id}
                                            style={{
                                                padding: '12px 15px',
                                                backgroundColor: selectedAreas.includes(area.area_id)
                                                    ? '#e3f2fd'
                                                    : '#fff',
                                                borderBottom: index < availableAreas.length - 1
                                                    ? '1px solid #f0f0f0'
                                                    : 'none',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s',
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderRadius: '4px',
                                                marginBottom: '5px'
                                            }}
                                            onClick={() => handleAreaToggle(area.area_id)}
                                            onMouseEnter={(e) => {
                                                if (!selectedAreas.includes(area.area_id)) {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!selectedAreas.includes(area.area_id)) {
                                                    e.currentTarget.style.backgroundColor = '#fff';
                                                }
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedAreas.includes(area.area_id)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleAreaToggle(area.area_id);
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    marginRight: '12px',
                                                    cursor: 'pointer',
                                                    width: '18px',
                                                    height: '18px'
                                                }}
                                            />
                                            <span style={{ fontSize: '15px', color: '#333', fontWeight: '500' }}>
                                                {area.area_name}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Modal Footer */}
                        <div style={{
                            padding: '15px 20px',
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px'
                        }}>
                            <button
                                type="button"
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
export default Editstaff